import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// 全局处理ResizeObserver错误
const resizeObserverErrorHandler = (e) => {
  if (e.message === 'ResizeObserver loop completed with undelivered notifications.') {
    // 这是一个已知的、无害的错误，通常发生在布局快速变化时
    // 我们可以安全地忽略它
    e.stopImmediatePropagation();
    e.preventDefault();
    return false;
  }
};

// 监听未捕获的错误
window.addEventListener('error', resizeObserverErrorHandler);

// 监听未处理的Promise rejection
window.addEventListener('unhandledrejection', (e) => {
  if (e.reason && e.reason.message && 
      e.reason.message.includes('ResizeObserver loop completed with undelivered notifications')) {
    e.preventDefault();
    return false;
  }
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
